import Vue from "vue";
import BaseComponent from "./core/base/BaseComponent";
import NotFoundComponent from "./core/base/NotFoundComponent";
import ActivitiesComponent from "./features/team-activity/ActivitiesComponent";
import TimesheetsComponent from "./features/timesheets/TimesheetsComponent";
import AllMembersComponent from "./features/timesheets/components/AllMembersComponent";
import MemberTimesheetsComponent from "./features/timesheets/components/MemberTimesheetsComponent";
import SettingsComponent from "./features/settings/SettingsComponent";
import ProfileComponent from "./features/settings/profile/ProfileComponent";
import NotificationsComponent from "./features/settings/notifications/NotificationsComponent";
import ManageTeamComponent from "./features/settings/manage-team/ManageTeamComponent";
import CompanyComponent from "./features/settings/company/CompanyComponent";
import WorkweekOvertimeComponent from "./features/settings/workweek-overtime/WorkweekOvertimeComponent";
import PtoComponent from "./features/settings/pto/PtoComponent";
import DepartmentsComponent from "./features/settings/departments/DepartmentsComponent";
import ViewDepartmentComponent from "./features/settings/departments/components/ViewDepartmentComponent";
import JobCodesComponent from "./features/settings/job-codes/JobCodesComponent";
import TimesheetReportComponent from "./features/settings/timesheet-report/TimesheetReportComponent";
import LocationTrackingComponent from "./features/settings/location-tracking/LocationTrackingComponent";
import ManualEntriesComponent from "./features/settings/manual-entries/ManualEntriesComponent";
import BreakPreferencesComponent from "./features/settings/break-preferences/BreakPreferencesComponent";
import TimeOptionsComponent from "./features/settings/time-options/TimeOptionsComponent";
import JobSitesComponent from "./features/settings/job-sites/JobSitesComponent";
// import ManualEntriesComponent from "./features/settings/views/ManualEntriesComponent";
import BillingComponent from "./features/settings/billing/BillingComponent";
import SubscriptionComponent from "./features/subscription/SubscriptionComponent";
import BillingInformationComponent from "./features/subscription/components/BillingInformationComponent";
import SubscriptionPlansComponent from "./features/subscription/components/SubscriptionPlansComponent";

import VueRouter from "vue-router";
import PermissionService from "./shared/services/PermissionService";
import AuthService from "./shared/services/AuthService";
import MobileComponent from "./core/base/MobileComponent";
import UtilsService from "./shared/services/UtilsService";
import AllDepartmentsComponent from "./features/settings/departments/components/AllDepartmentsComponent";
import IntegrationsComponent from "./features/settings/integrations/IntegrationsComponent";
import AllManageTeamComponent from "./features/settings/manage-team/components/AllManageTeamComponent";
import MemberProfileComponent from "./features/settings/manage-team/components/MemberProfileComponent";
import InviteProfileComponent from "./features/settings/manage-team/components/InviteProfileComponent";
import AllJobCodesComponent from "./features/settings/job-codes/components/AllJobCodesComponent";
import ArchivedMembersComponent from "./features/timesheets/components/ArchivedMembersComponent";
import TimeEntryDetailComponent from "./features/timesheets/components/TimeEntryDetailComponent";
import TimeEntryDailyComponent from "./features/timesheets/components/TimeEntryDailyComponent";
import TimeClockComponent from "./features/settings/time-clock/TimeClockComponent";
import Chat from "./features/chat/Chat";
import PayrollComponent from "./features/payroll/PayrollComponent";
import ExportXeroTimesheetsComponent from "./features/settings/company/components/ExportXeroTimesheetsComponent.vue";
import ImportXeroEmployeesComponent from "./features/settings/company/components/ImportXeroEmployeesComponent.vue";
import ImportXeroPayItemsComponent from "./features/settings/company/components/ImportXeroPayItemsComponent.vue";
import ImportXeroPayCalendarsComponent from "./features/settings/company/components/ImportXeroPayCalendarsComponent.vue";
import ImportQuickBooksComponent from "./features/settings/company/components/ImportQuickBooksComponent.vue";

Vue.use(VueRouter);

let router = new VueRouter({
  //mode: 'history',
  routes: [
    {
      path: "/",
      mode: "history",
      component: BaseComponent,
      redirect: "/activity",
      children: [
        {
          path: "activity",
          component: ActivitiesComponent,
          meta: {
            canAccess: PermissionService.canAccessActivities(),
            title: "Atto: Team Activity",
            mobile: false,
          },
        },
        {
          path: "/timesheets",
          component: TimesheetsComponent,
          redirect: "/timesheets/all",
          meta: {
            canAccess: PermissionService.canAccessCompanySettings,
          },
          children: [
            {
              path: "all",
              name: "AllMemberTimesheets",
              component: AllMembersComponent,
              meta: {
                canAccess: PermissionService.canAccessAllTimesheets(),
                title: "Atto: Timesheets",
                mobile: false,
              },
            },
            {
              path: "archived",
              name: "ArchivedMemberTimesheets",
              component: ArchivedMembersComponent,
              meta: {
                canAccess: PermissionService.canAccessAllTimesheets(),
                title: "Atto: Timesheets",
                mobile: false,
              },
            },
            {
              path: "member/:uid",
              name: "MemberTimesheets",
              component: MemberTimesheetsComponent,
              meta: {
                canAccess: true,
                title: "Atto: Timesheets",
                mobile: false,
              },
            },
            {
              path: "member/:uid/:id",
              name: "TimeEntryDetail",
              component: TimeEntryDetailComponent,
              meta: {
                canAccess: true,
                title: "Atto: Timesheets",
                mobile: false,
              },
            },
            {
              path: "member/:uid/:date/daily",
              name: "TimeEntryDaily",
              component: TimeEntryDailyComponent,
              meta: {
                canAccess: true,
                title: "Atto: Timesheets",
                mobile: false,
              },
            },
          ],
        },
        {
          path: "/payroll",
          component: PayrollComponent,
          meta: {
            canAccess: true,
            title: "Atto: Payroll",
            mobile: true,
          },
        },
        {
          path: "/settings",
          component: SettingsComponent,
          meta: {
            canAccess: PermissionService.canAccessCompanySettings,
          },
          redirect: "/settings/profile",
          children: [
            {
              path: "/settings/profile",
              component: ProfileComponent,
              meta: {
                canAccess: true,
                title: "Atto: Settings",
                mobile: false,
              },
            },
            {
              path: "/settings/notifications",
              component: NotificationsComponent,
              meta: {
                canAccess: true,
                title: "Atto: Settings",
                mobile: false,
              },
            },
            {
              path: "/settings/subscription",
              component: BillingComponent,
              meta: {
                canAccess: true,
                title: "Atto: Settings",
                mobile: true,
              },
            },
            {
              path: "/settings/integrations",
              component: IntegrationsComponent,
              meta: {
                canAccess: true,
                title: "Atto: Settings",
                mobile: true,
              },
            },
            {
              path: "/settings/company",
              component: CompanyComponent,
              meta: {
                canAccess: true,
                title: "Atto: Settings",
                mobile: false,
              },
            },
            {
              path: "/settings/manage-team",
              component: ManageTeamComponent,
              meta: {
                canAccess: true,
                title: "Atto: Settings",
                mobile: false,
              },
              children: [
                {
                  path: "",
                  name: "AllManageTeamComponent",
                  component: AllManageTeamComponent,
                  meta: {
                    canAccess: true,
                    title: "Atto: Settings",
                    mobile: false,
                  },
                },
                {
                  path: ":uid",
                  name: "MemberProfileComponent",
                  component: MemberProfileComponent,
                  meta: {
                    canAccess: true,
                    title: "Atto: Settings",
                    mobile: false,
                  },
                },
                {
                  path: ":id/invite",
                  name: "InviteProfileComponent",
                  component: InviteProfileComponent,
                  meta: {
                    canAccess: true,
                    title: "Atto: Settings",
                    mobile: false,
                  },
                },
              ],
            },
            {
              path: "/settings/time-clock",
              component: TimeClockComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/departments",
              component: DepartmentsComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
              children: [
                {
                  path: "",
                  component: AllDepartmentsComponent,
                  meta: {
                    canAccess: true,
                    title: "Atto: Settings",
                    mobile: false,
                  },
                },
                {
                  path: ":did",
                  name: "Department",
                  component: ViewDepartmentComponent,
                  meta: {
                    canAccess: true,
                    title: "Atto: Settings",
                    mobile: false,
                  },
                },
              ],
            },
            {
              path: "/settings/workweek-overtime",
              component: WorkweekOvertimeComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/break-preferences",
              component: BreakPreferencesComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/time-options",
              component: TimeOptionsComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/pto",
              component: PtoComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/job-codes",
              component: JobCodesComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
              children: [
                {
                  path: "",
                  component: AllJobCodesComponent,
                  meta: {
                    canAccess: true,
                    title: "Atto: Settings",
                    mobile: false,
                  },
                },
              ],
            },
            {
              path: "/settings/timesheet-report",
              component: TimesheetReportComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/manual-entries",
              component: ManualEntriesComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/location-tracking",
              component: LocationTrackingComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/job-sites",
              component: JobSitesComponent,
              meta: {
                canAccess: true,
                mobile: false,
              },
            },
            {
              path: "/settings/xero/export",
              component: ExportXeroTimesheetsComponent,
              meta: {
                canAccess: true,
                title: "Atto: Xero Export",
                mobile: true,
              },
            },
            {
              path: "/settings/xero/import",
              component: ImportXeroEmployeesComponent,
              meta: {
                canAccess: true,
                title: "Atto: Xero Import",
                mobile: true,
              },
            },
            {
              path: "/settings/xero/updatePayItems",
              component: ImportXeroPayItemsComponent,
              meta: {
                canAccess: true,
                title: "Atto: Xero Pay Items",
                mobile: true,
              },
            },
            {
              path: "/settings/xero/updatePayCalendar",
              component: ImportXeroPayCalendarsComponent,
              meta: {
                canAccess: true,
                title: "Atto: Xero Pay Calendar",
                mobile: true,
              },
            },
            {
              path: "/settings/quickbooks/import",
              component: ImportQuickBooksComponent,
              meta: {
                canAccess: true,
                title: "Atto: QuickBooks Import",
                mobile: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: "/subscription",
      component: SubscriptionComponent,
      redirect: "/subscription/plans",
      children: [
        {
          path: "plans",
          component: SubscriptionPlansComponent,
          meta: {
            canAccess: PermissionService.canAccessSubscriptions(),
            title: "Atto: Subscribe Now",
            mobile: true,
          },
        },
        {
          path: "billing-information",
          component: BillingInformationComponent,
          meta: {
            canAccess: PermissionService.canAccessSubscriptions(),
            title: "Atto: Subscribe Now",
            mobile: true,
          },
        },
      ],
    },
    {
      path: "/404",
      name: "NotFound",
      component: NotFoundComponent,
      meta: {
        canAccess: true,
        title: "Atto: Not Found",
        mobile: false,
      },
    },
    {
      path: "/mobile",
      name: "Mobile",
      component: MobileComponent,
      meta: {
        canAccess: true,
        mobile: true,
      },
    },
    { path: "*", redirect: "/404" },
  ],
});

Vue.router = router;

Vue.router.beforeEach((to, from, next) => {
  const { canAccess, mobile, title } = to.meta;
  const isMobileDevice = UtilsService.isMobile.any();
  const user = AuthService.getUser();

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const isXero = params.get("redirectToXero");

  const redirects = {
    "app.attotime.com": "https://dashboard.attotime.com/",
    "app.atto.spectalabs.dev": "https://dashboard.atto.spectalabs.dev/",
    // localhost: "http://localhost:3000", // Only for localhost development
  };

  const hostname = window.location.hostname;
  const redirectUrl = redirects[hostname];

  if (redirectUrl && !token && !isXero) {
    let finalRedirect = redirectUrl;
    if (to && to.fullPath && to.fullPath.includes("/settings")) {
      finalRedirect = redirectUrl.replace(/\/$/, "") + "/settings";
    }

    window.location.replace(finalRedirect);
    return;
  }

  if (title) {
    window.document.title = title;
  }

  if (isMobileDevice) {
    if (!user) {
      if (to.path === "/payroll") {
        localStorage.setItem("preLoginRoute", "/payroll");
        next({ path: "/login" });
        return;
      } else {
        next({ path: "/mobile" });
        return;
      }
    } else if (localStorage.getItem("preLoginRoute")) {
      const preLoginRoute = localStorage.getItem("preLoginRoute");
      localStorage.removeItem("preLoginRoute");
      next({ path: preLoginRoute });
      return;
    }
  }

  if (canAccess) {
    if (isMobileDevice && !mobile) {
      router.push({ path: "/mobile" });
    } else {
      /*const user = AuthService.getUser();
            if(user !== null && user.id === 281511) {
                if(to.fullPath !== '/settings/subscription' && to.fullPath !== '/settings/profile'
                    && to.fullPath !== '/subscription/plans' && to.fullPath !== '/subscription/billing-information') {
                    router.push('/settings/subscription');
                } else {
                    next();
                }

            } else {*/
      next();
      /*}*/
    }
  } else {
    if (user !== null) {
      router.push({ name: "MemberTimesheets", params: { uid: user.uid } });
    }
  }
});

export default new VueRouter({
  router,
});
